// // console.log("TEsting")
// let collectionsArray = [];
// const facets_Selected = document.querySelectorAll(
//   ".facets__header > .facets__selected"
// );
// const resetButtonCustom = document.querySelector(".reset-label");
// const facetDrawer = document.querySelector("#FacetDrawer");
// const observer = new MutationObserver(handleAttributeChanges);
// const config = { attributes: true, subtree: true, attributeFilter: ["open"] };

// function updateCollectionsArray() {
//   document
//     .querySelectorAll(".facets__header > .facets__selected")
//     .forEach((item) => {
//       let textContent;
//       let countBubbleSpan = item.querySelector(".count-bubble");

//       if (countBubbleSpan) {
//         textContent = item.childNodes[0].textContent.trim();
//       } else {
//         textContent = item.textContent.trim();
//       }

//       if (textContent.includes("tea") || textContent.includes("Tea")) {
//         let className = `facets__selected collection_name_custom ${textContent.replace(
//           /[^a-zA-Z0-9-_]/g,
//           ""
//         )}`;
//         let dataValue = textContent.replaceAll(" ", "-").toLowerCase();
//         dataValue = `collections/${dataValue}`;

//         item.classList.value = className;
//         item.setAttribute("data-collection", dataValue);
//         if (!collectionsArray.includes(item)) {
//           collectionsArray.push(item);
//         }
//       }
//     });
// }

// function triggerRedirection() {
//  collectionsArray.forEach((collection) => {
//    collection.addEventListener("click", () => {
//      const dataCollection = collection.getAttribute("data-collection");
//      window.location.href = `/${dataCollection}`;
//    });
//  });   
// }

// function handleAttributeChanges(mutationsList, observer) {
//   for (let mutation of mutationsList) {
//     if (mutation.type === "attributes" && mutation.attributeName === "open") {
//       const target = mutation.target;
//       if (!target.hasAttribute("open")) {
//         target.setAttribute("open", "open");
//       }
//     }
//   }
// }

// observer.observe(facetDrawer, config);

// updateCollectionsArray();
// triggerRedirection();

// facetDrawer.querySelectorAll("*").forEach(element => {
//     element.addEventListener('click', () => {
//     updateCollectionsArray();
//     triggerRedirection();   
//    })
// })


// if (resetButtonCustom) {
//   resetButtonCustom.addEventListener("click", function () {
//     let resetUrl = window.location.href.split("?")[0];
//     // window.location.replace(resetUrl);
//       debugger;
//     let indexOfCollection = resetUrl.indexOf("/collections/");
//     let redirectUrl = `${resetUrl.slice("0",indexOfCollection)}/collections/all`;
//   // console.log(resetUrl.slice("0",indexOfCollection));
//   window.location.replace(redirectUrl);
//   });
// }



// // Custom Section Hide 

// document.addEventListener("DOMContentLoaded", function() {
//   const tabCollageItemsListCheck = document.querySelector(".tab-collage__content");
//     if (tabCollageItemsListCheck.textContent.trim() === "") {
//     document.querySelectorAll(".tab-collage__content").forEach(section => {
//       section.parentElement.parentElement.style.display = "none";
//     });
//   }
// });

// Custom remove filter or custom Rest 

  const resetButtonCustom = document.querySelector(".reset-label");
  if (resetButtonCustom) {
  resetButtonCustom.addEventListener("click", function () {
    let resetUrl = window.location.href.split("?")[0];
    // window.location.replace(resetUrl);
      debugger;
    let indexOfCollection = resetUrl.indexOf("/collections/");
    let redirectUrl = `${resetUrl.slice("0",indexOfCollection)}/collections/all`;
  // console.log(resetUrl.slice("0",indexOfCollection));
  window.location.replace(redirectUrl);
  });
}


document.addEventListener('DOMContentLoaded', function () {
  const firstButton = document.querySelector('.first-button a');

  firstButton.addEventListener('click', function () {
    event.preventDefault();
    const secondButton = document.querySelector('.second-button a');
    secondButton.click();
  });
});


// Hide show filters on click 
// function ctmFilter() {
//   var x = document.getElementById("hide_show_onclick");
//   if (x.style.display === "none") {
//     x.style.display = "block";
//   } else {
//     x.style.display = "none";
//   }
// }

function ctmFilter() {
  var filterSection = document.getElementById("hide_show_onclick");
  var productGrid = document.getElementById("product-grid");

  if (filterSection.style.display === "none") {
    filterSection.style.display = "block";
    productGrid.classList.remove("ctm_grid--5-col-desktop");
    productGrid.classList.add("grid--4-col-desktop");
  } else {
    filterSection.style.display = "none";
    productGrid.classList.remove("grid--4-col-desktop");
    productGrid.classList.add("ctm_grid--5-col-desktop");
  }
}


// Custom reset enable disable 
// document.addEventListener('DOMContentLoaded', function() {
//   const checkboxes = document.querySelectorAll('.facet-checkbox input[type=checkbox]');
//   const resetButton = document.querySelector('.reset-label_filter_button');

//   function updateResetButtonVisibility() {
//     let anyChecked = false;
//     checkboxes.forEach(checkbox => {
//       if (checkbox.checked) {
//         anyChecked = true;
//       }
//     });
//     resetButton.style.display = anyChecked ? 'inline' : 'none';
//   }

//   // Add event listeners to checkboxes
//   checkboxes.forEach(checkbox => {
//     checkbox.addEventListener('change', updateResetButtonVisibility);
//   });

//   // Initial check on page load
//   updateResetButtonVisibility();
// });

